import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { COLORS } from "~/ui/tokens";

export const changesLabel = (count) => (count === 1 ? "1 alteração não salva" : `${count} alterações não salvas`);

export default function ChangesBar({ count, summary, onDiscard, onSave }) {
  if (!count) return null;
  return (
    <Box
      role="region"
      aria-label="Alterações não salvas"
      sx={{ position: "sticky", bottom: 16, mt: 3, display: "flex", alignItems: "center", gap: 2, px: 2.5, py: 1.5, borderRadius: 2, bgcolor: COLORS.primary, color: "#fff", boxShadow: 6, zIndex: 3 }}
    >
      <Box sx={{ width: 28, height: 28, borderRadius: "50%", bgcolor: COLORS.accent, color: COLORS.primary, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>
        {count}
      </Box>
      <Typography sx={{ fontWeight: 600 }}>{changesLabel(count)}</Typography>
      <Typography variant="body2" sx={{ opacity: 0.8, flexGrow: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{summary}</Typography>
      <Button color="inherit" onClick={onDiscard} sx={{ fontWeight: 600 }}>Descartar</Button>
      <Button variant="contained" startIcon={<SaveOutlinedIcon />} onClick={onSave} sx={{ bgcolor: COLORS.accent, color: COLORS.primary, fontWeight: 700, "&:hover": { bgcolor: "#04a5ca" } }}>
        Salvar
      </Button>
    </Box>
  );
}
